import { render, staticRenderFns } from "./SpeechPlayer.vue?vue&type=template&id=359b9385&scoped=true"
import script from "./SpeechPlayer.vue?vue&type=script&lang=js"
export * from "./SpeechPlayer.vue?vue&type=script&lang=js"
import style0 from "./SpeechPlayer.vue?vue&type=style&index=0&id=359b9385&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359b9385",
  null
  
)

export default component.exports